import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import UserContext from '../../../config/UserContext'
import { HttpService, API, swal, Title, toast, Messages, DateFormat } from '../../../config/react'
import DataTable from 'react-data-table-component'

const DiamondQuality = () => {
  const [QualityList, setQualityList] = useState([])
  const user = useContext(UserContext)
  const [isForceUpdate, setForceUpdate] = useState(false)

  const columns = [
    {
      name: 'Clarity',
      selector: (row) => row.clarity
    },
    {
      name: 'Color',
      selector: (row) => row.color
    },
    {
      name: 'Stone Quality',
      selector: (row) => row.stone_quality
    },
    {
      name: 'Created Date',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Status',
      selector: (row) => (row.status === 1 ? <label>Active</label> : <label>Inactive</label>)
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/system/diamondquality/edit/' + row.id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          <Link
            onClick={(e) => DeleteQuality(e, row.id)}
            to=""
            className="text-dark"
            title="Delete"
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]

  const DefaultFilters = {
    page: 1,
    search: '',
    page_size: 10
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  useEffect(() => {
    document.title = Title.DiamondQuality
    GetQualityList()
  }, [CustomFilters])

  const GetQualityList = () => {
    const passData = {
      page: CustomFilters.page,
      search: CustomFilters.search,
      page_size: CustomFilters.page_size
    }
    HttpService.postApi(API.GetStoneQualityAdminList, passData).then((response) => {
      if (response.data.status === true) {
        const data = response.data.result[1]
        // var data = response.data.result[0];

        setQualityList(data)
        setForceUpdate(!isForceUpdate)
        settotalRows(response.data.result[0][0].total_row)
      }
    })
  }
  const handlePageChange = (e) => {
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCustomFilters({ ...CustomFilters, page_size: e })
  }

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Clarity, Color."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) => setCustomFilters({ ...CustomFilters, search: e.target.value })}
      />
    )
  })

  const DeleteQuality = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id,
          IsDeleted: true,
          deleted_by: user.id
        }
        HttpService.postApi(API.DeleteDiamondQuality, param).then((response) => {
          toast.success(Messages.RecordDeleted)
          GetQualityList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }

  return (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.DiamondQuality} </h3>
        <div className="btn-group">
          <Link
            to="/system/diamondquality/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            Add Diamond Quality{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={QualityList}
                  pagination
                  persistTableHead={true}
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DiamondQuality
